// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2uTfb","form":"styles_form__1Ty0C"};